import EventBus from '../wirebox/event-bus'
import './modals'

EventBus.subscribe('modal.error', ({html, title}) => {
    EventBus.publish('create-modal', {
        body: html,
        header: `<h5 class="modal-title"><i class="icon-attention-alt" aria-hidden="true"></i> ${title}</h5>`,
        headerClasses: 'bg-danger text-white',
        size: ''
    })
})